import { useHMSSpectators } from "../hms";
import { useLivekitSpectators } from "../livekit";
import { useProviderHook } from "./useProviderHook";

export const useProviderSpectators = () =>
  useProviderHook({
    hms: useHMSSpectators,
    livekit: useLivekitSpectators,
  })();
